module.exports = __webpack_public_path__ + "img/timer.2d88aad2.svg";